export default __webpack_public_path__ + "fonts/4c9dabf0381900ef60f96ab0dd286552.svg";